import { find, trim , toUpper, get, isEmpty, gt} from 'lodash';
export const duplicateCheck = (collection, field, obj) => {
    const selected = find(collection, (ele) => {
        // eslint-disable-next-line
        return trim(ele[field]) == trim(obj[field])
    })
    // eslint-disable-next-line
    if (selected && (!obj.id || selected.id != obj.id)) {
        return true
    }
    return false;
}

export const GetClientOrDependentName = (data)=>{
    let name = ""
    switch(get(data.occupantType, "code")){
        case "CLIENT":
            name = `${data.client.lastName},${data.client.firstName}`
        break;
        case "DEPENDENT": 
            name = `${data.dependentName} (${data.client.lastName}, ${data.client.firstName})`
        break;
        default:
        break
    }
    return name;
}

export const GetAvailableBedCapacityColor = (node)=>{
    let color = ""
    let values =  get(node.data, "action").split(" ")   
    if(!isEmpty(values) && gt(values.length, 0)){
        color = gt(+values[0], 0)?"#A31922":""
    }
   
    return color;
}


export const GetAvailableBedCapacity = (node)=>{   
    let values =  get(node.data, "action").split(" ")   
    if(!isEmpty(values) && gt(values.length, 0)){
       return +values[0]
    }
   
    return 0;
}

export const GetTotalBedCapacity = (node)=>{   
    let values =  get(node.data, "action").split(" ")   
    if(!isEmpty(values) && gt(values.length, 0)){
       return +values[2]
    }
   
    return 0;
}

export const capitalizeFirstLetter = (value)=> {
    var splitStr = value.toLowerCase().split(" ")
    for (var i = 0; i < splitStr.length; i++) {   
        splitStr[i]=  splitStr[i].charAt(0).toUpperCase() +  splitStr[i].toLowerCase().slice(1);     
      }
      value = splitStr.join(" ");
   
    return value;
  }